import { createReducer } from '../helpers/redux-helpers'
import { FsCore } from 'types/fs-core'
import {
  updateAllicaResults,
  updateSmeBusinessFinanceResults,
  updateSmeProfile,
} from './sme-actions'

const smeReducer = createReducer<FsCore.SmeState>(
  {
    [updateSmeProfile]: (state, profile: FsCore.SmeProfile) => {
      return {
        ...state,
        profile,
      }
    },

    [updateSmeBusinessFinanceResults]: (state, results: FsCore.BusinessFinanceResults) => {
      return {
        ...state,
        businessFinanceResults: results,
      }
    },
    [updateAllicaResults]: (state, results: FsCore.AllicaResults) => {
      return {
        ...state,
        allicaResults: results,
      }
    },
  },
  {},
)

export default smeReducer
